import { Routes } from '@angular/router';
import { mechanicAlgorithmRoutes } from './algorithm/routes';
import { mechanicDictationRoutes } from './dictation/routes';
import { mechanicExpressionRoutes } from './expression/routes';
import { MechanicsPage } from './mechanics-page';
import { mechanicMorphemeRoutes } from './morphemes/routes';
import { mechanicPhoneticComprehensionRoutes } from './phonetic-comprehension/routes';
import { mechanicReadingBasisRoutes } from './reading-basis/routes';
import { mechanicReadingMatrixRoutes } from './reading-matrix/routes';
import { mechanicSortingRoutes } from './sorting/routes';
import { mechanicSyllabicKeyboardPlusRoutes } from './syllabic-keyboard-plus/routes';
import { mechanicSyllabicKeyboardRoutes } from './syllabic-keyboard/routes';

export const mechanicRoutes: Routes = [
  {
    path: '',
    component: MechanicsPage,
  },
  {
    path: 'sorting',
    children: mechanicSortingRoutes,
  },
  {
    path: 'reading-basis',
    children: mechanicReadingBasisRoutes,
  },
  {
    path: 'reading-matrix',
    children: mechanicReadingMatrixRoutes,
  },
  {
    path: 'dictation',
    children: mechanicDictationRoutes,
  },
  {
    path: 'syllabic-keyboard',
    children: mechanicSyllabicKeyboardRoutes,
  },
  {
    path: 'syllabic-keyboard-plus',
    children: mechanicSyllabicKeyboardPlusRoutes,
  },
  {
    path: 'phonetic-comprehension',
    children: mechanicPhoneticComprehensionRoutes,
  },
  {
    path: 'expression',
    children: mechanicExpressionRoutes,
  },
  {
    path: 'algorithm',
    children: mechanicAlgorithmRoutes,
  },
  {
    path: 'morphemes',
    children: mechanicMorphemeRoutes,
  },
];
